export const MENU_ACTION_DUPLICATE = { text: 'Copy', action: 'DUPLICATE' };
export const MENU_ACTION_EDIT_ORIGINAL = { text: 'Edit Original', action: 'EDIT_ORIGINAL' };
export const MENU_ACTION_DELETE = { text: 'Delete', action: 'DELETE' };
export const COMPONENT_MENU_READER_ACTIONS = [MENU_ACTION_EDIT_ORIGINAL];

export const COMPONENT_MENU_EDITOR_ACTIONS = [
  MENU_ACTION_DELETE,
  MENU_ACTION_DUPLICATE,
  MENU_ACTION_EDIT_ORIGINAL
];

export const MENU_ACTION_INSERT_INTO_PAGE = { text: 'Add', action: 'INSERT_INTO_PAGE' };
export const MENU_ACTION_INSERT_DUPLICATE_INTO_PAGE = {
  text: 'Copy',
  action: 'INSERT_DUPLICATE_INTO_PAGE'
};
export const MENU_ACTION_INSERT_INTO_CONTAINER = { text: 'Add', action: 'ITEM_CLICK' };
export const MENU_ACTION_INSERT_DUPLICATE_INTO_CONTAINER = {
  text: 'Copy',
  action: 'INSERT_DUPLICATE_INTO_CONTAINER'
};

export const PAGE_COMPONENT_MENU_READER_ACTIONS = [MENU_ACTION_EDIT_ORIGINAL];

export const PAGE_COMPONENT_MENU_EDITOR_ACTIONS = [
  MENU_ACTION_DELETE,
  MENU_ACTION_EDIT_ORIGINAL,
  MENU_ACTION_INSERT_DUPLICATE_INTO_PAGE,
  MENU_ACTION_INSERT_INTO_PAGE
];

export const PAGE_CONTAINER_MENU_READER_ACTIONS = [MENU_ACTION_EDIT_ORIGINAL];

export const PAGE_CONTAINER_MENU_EDITOR_ACTIONS = [
  MENU_ACTION_DELETE,
  MENU_ACTION_EDIT_ORIGINAL,
  MENU_ACTION_INSERT_DUPLICATE_INTO_CONTAINER,
  MENU_ACTION_INSERT_INTO_CONTAINER
];

export const MENU_ACTION_UNFAVORITE = { text: 'Unfavorite', action: 'UNFAVORITE' };
export const MENU_ACTION_FAVORITE = { text: 'Favorite', action: 'FAVORITE' };

export const ITEM_CLICK_ACTION = { text: '', action: 'ITEM_CLICK' };

export const CONTEXT = {
  COMPONENT: 'component',
  PAGE_OR_FOLDER: 'pageOrFolder',
  PAGE: 'page'
};

export const PAGE_ACTIONS_FAVORITE = [
  MENU_ACTION_DELETE,
  MENU_ACTION_DUPLICATE,
  MENU_ACTION_FAVORITE
];

export const PAGE_ACTIONS_UNFAVORITE = [
  MENU_ACTION_DELETE,
  MENU_ACTION_DUPLICATE,
  MENU_ACTION_UNFAVORITE
];
